import React from 'react';

export type IconPosition = 'left' | 'right';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  iconSrc?: string; // public path e.g. /figma_asset/Plus square.svg
  iconAlt?: string;
  iconPosition?: IconPosition; // default left
  className?: string;
  variant?: 'primary' | 'secondary'; // extendable
}

// Figma primary style (Plus square button): bg #ff7a7a, rounded 20px, gap 5px, px 14, py 10
const variantClasses: Record<string, string> = {
  primary: 'bg-[#ff7a7a] text-white',
  // Figma secondary: white background, border & text #ff7a7a
  secondary: 'bg-white text-[#ff7a7a] border border-[#ff7a7a]',
};

export const IconButton: React.FC<IconButtonProps> = ({
  label,
  iconSrc,
  iconAlt = '',
  iconPosition = 'left',
  className = '',
  variant = 'primary',
  type = 'button',
  ...rest
}) => {
  const base =
    'flex items-center justify-center rounded-[20px] gap-[5px] px-[14px] py-[10px] text-[16px] font-normal select-none';
  const style = variantClasses[variant] || variantClasses.primary;

  const icon = iconSrc ? (
    <img src={iconSrc} alt={iconAlt} className="w-[20px] h-[20px]" aria-hidden={iconAlt === ''} />
  ) : null;

  return (
    <button type={type} className={`${base} ${style} ${className}`} {...rest}>
      {iconPosition === 'left' && icon}
      <span className="leading-none">{label}</span>
      {iconPosition === 'right' && icon}
    </button>
  );
};

export default IconButton;
